import { render, staticRenderFns } from "./mVideo.vue?vue&type=template&id=20b8d330&scoped=true"
import script from "./mVideo.vue?vue&type=script&lang=js"
export * from "./mVideo.vue?vue&type=script&lang=js"
import style0 from "./mVideo.vue?vue&type=style&index=0&id=20b8d330&lang=css"
import style1 from "./mVideo.vue?vue&type=style&index=1&id=20b8d330&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/registry.npmmirror.com+vue-loader@15.11.1_babel-core@6.26.3_cache-loader@4.1.0_css-loader@3.6_es6nbxkbffq4rffv33bwkugdri/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20b8d330",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Project\\bluetooth-light-web\\node_modules\\.pnpm\\registry.npmmirror.com+vue-hot-reload-api@2.3.4\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('20b8d330')) {
      api.createRecord('20b8d330', component.options)
    } else {
      api.reload('20b8d330', component.options)
    }
    module.hot.accept("./mVideo.vue?vue&type=template&id=20b8d330&scoped=true", function () {
      api.rerender('20b8d330', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/business/mVideo/mVideo.vue"
export default component.exports